import React from 'react';
import LoadingSpinner from '../../../components/ui/LoadingSpinner';
import Icon from '../../../components/AppIcon';

const SelectHotelLoading = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-blue-50 flex items-center justify-center p-4">
      <div className="text-center">
        <div className="w-12 h-12 sm:w-16 sm:h-16 bg-blue-100 rounded-xl flex items-center justify-center mx-auto mb-4">
          <Icon name="Hotel" size={24} color="var(--color-blue-600)" className="sm:hidden" />
          <Icon name="Hotel" size={32} color="var(--color-blue-600)" className="hidden sm:block" />
        </div>
        <LoadingSpinner size="lg" className="mx-auto mb-4" />
        <p className="text-slate-600 text-sm sm:text-base">Carregando hotéis disponíveis...</p>
      </div>
    </div>
  );
};

export default SelectHotelLoading;
